import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid as MuiGrid,
} from '@mui/material';
import { motion } from 'framer-motion';
import { School as SchoolIcon } from '@mui/icons-material';

const MotionPaper = motion.create(Paper);
const Grid = MuiGrid as any;

interface EducationItem {
  degree: string;
  institution: string;
  period: string;
  description: string;
  achievements?: string[];
}

const education: EducationItem[] = [
  {
    degree: 'Deep Learning AI: Machine Learning Specialization and Deep Learning',
    institution: 'Deep Learning AI',
    period: '2023',
    description: 'Completed the Machine Learning Specialization and Deep Learning courses from DeepLearning.AI, focusing on neural networks, deep learning architectures, and real-world AI applications.',
  },
  {
    degree: 'Data Science and Data Engineering Boot Camp',
    institution: 'Data Science Dojo',
    period: '2017',
    description: 'The Data Science and Data Engineering Bootcamp by Data Science Dojo provided hands-on training in data analysis, machine learning, and big data tools to build end-to-end data solutions.',
  },
  {
    degree: 'Computer Science (BS)',
    institution: 'DeVry University',
    period: '1994-1997',
    description: 'Coursework in pursuit of Bachelor of Science in Computer Science from DeVry University with a focus on software development, algorithms, and data structures.',
  },
  {
    degree: 'Electronic Engineering Technology (BS)',
    institution: 'DeVry University',
    period: '1993-1994',
    description: 'Coursework in pursuit of Bachelor of Science in Electronics Engineering Technology from DeVry University with hands-on training in circuit design, microprocessors, and automation systems.',
  },
];

const Education = () => {
  return (
    <Box sx={{ py: { xs: 2, md: 4 } }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Education
      </Typography>
      
      <Grid container spacing={4}>
        {education.map((item, index) => (
          <Grid key={index} sx={{ gridColumn: 'span 12' }}>
            <MotionPaper
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              sx={{
                p: { xs: 2, md: 3 },
                backgroundColor: 'background.paper',
                borderRadius: 2,
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: 4,
                  backgroundColor: 'primary.main',
                  borderRadius: '4px 0 0 4px',
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <SchoolIcon sx={{ color: 'primary.main', mr: 2 }} />
                <Box>
                  <Typography variant="h6" component="h2">
                    {item.degree}
                  </Typography>
                  <Typography variant="subtitle1" color="primary">
                    {item.institution}
                  </Typography>
                  <Typography variant="subtitle2" color="text.secondary">
                    {item.period}
                  </Typography>
                </Box>
              </Box>
              
              <Typography variant="body1" color="text.secondary" paragraph>
                {item.description}
              </Typography>
              
              {item.achievements && (
                <Box component="ul" sx={{ mt: 2, pl: 2 }}>
                  {item.achievements.map((achievement, i) => (
                    <Typography
                      component="li"
                      variant="body1"
                      key={i}
                      sx={{ mb: 1 }}
                    >
                      {achievement}
                    </Typography>
                  ))}
                </Box>
              )}
            </MotionPaper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Education; 